import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Menu } from "lucide-react";
import { Sidebar } from "./Sidebar";
import { AuthGate } from "@/lib/auth";

export function AppShell() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  // Close the drawer on every navigation — without this, tapping a nav
  // link on mobile would leave the (now-stale) drawer open over the new
  // page instead of getting out of the way, since Sidebar's own onClick
  // only fires for the click that INITIATED the navigation, not a
  // subsequent browser back/forward or programmatic navigate() elsewhere.
  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  return (
    <AuthGate>
      <div className="flex min-h-screen">
        <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <div className="flex-1 flex flex-col min-w-0">
          {/* Mobile-only top bar — the sidebar is a slide-in drawer below
           * the md breakpoint (see Sidebar's own header comment), so this
           * is the only way to open it, and the only place "Pure" is
           * visible at all once the permanent sidebar is hidden. */}
          <header className="flex items-center gap-3 border-b bg-card px-4 py-3 md:hidden">
            <button
              type="button"
              onClick={() => setSidebarOpen(true)}
              aria-label="Open navigation"
              className="rounded-md p-1.5 hover:bg-accent"
            >
              <Menu className="h-5 w-5" />
            </button>
            <div className="font-semibold">Pure</div>
          </header>
          <main className="flex-1 p-4 md:p-6 bg-muted/20 overflow-x-hidden">
            <Outlet />
          </main>
        </div>
      </div>
    </AuthGate>
  );
}
